// OTPForm.jsx
import React, { useEffect, useState } from 'react';
import { Field, ErrorMessage } from 'formik';
import { handleWA_text_sms } from './shopModel';

const OTPForm = ({mob,otp}) => {
  const [timer, setTimer] = useState(0);
  const [smsLoading, setSmsLoading] = useState(false);
   // Format timer mm:ss
   const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, '0');
    const s = String(seconds % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  // Timer effect
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  return (<>
    <div className="mb-3">
      <label htmlFor="user_otp" className="form-label">OTP</label>
      <div className="input-group input-group-sm">
        <Field
          id="user_otp"
          name="user_otp"
          className="form-control"
          inputMode="numeric"
          maxLength="4"
          onInput={e => {
            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 4);
          }}
        />
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={()=>{
            setSmsLoading(true);
            setTimer(120); // 2 minutes
            handleWA_text_sms({setSmsLoading,mob,otp})
          }}
          style={{ whiteSpace: 'nowrap' }}
          disabled={timer > 0}
        >
          {timer > 0
            ? `Resend OTP (${formatTime(timer)})`
            : smsLoading
            ? `Resend OTP`
            : 'Send OTP'}
        </button>
      </div>
      <ErrorMessage name="user_otp" component="div" className="text-danger small" />
    </div>
  </>
)
};

export default OTPForm;
